import { Alert, AlertColor, Snackbar } from "@mui/material";

type UniversalSnackbarProps = {
    visible: boolean;
    onSnackbarClose: any;
    severity: AlertColor;
    message: string;
}

export const UniversalSnackbar : React.FunctionComponent<UniversalSnackbarProps> = (props) => {
    const vertical = 'bottom';
	const horizontal = 'center';

    return (
        <Snackbar 
            anchorOrigin={{horizontal, vertical}}
            open={props.visible}
            onClose={props.onSnackbarClose}
            autoHideDuration={15000}
        >
            <Alert onClose={props.onSnackbarClose} severity={props.severity} sx={{width:'100%'}}>
                {props.message}
            </Alert>
        </Snackbar>
);
}